<template>
    <div class="dark login-dark container responsive" :style="{backgroundImage: backgroundImage}">
        <div class="box">
            <div class="card card-w-title">
                <div style="text-align: center">
                    <img style="max-width: 275px; max-height: 150px;" :src="logo" alt="">
                </div>
                <h1>{{ $t('auth.welcome') }}</h1>
                <form @submit.prevent="login()">
                    <div class="p-col-12">
                        <label htmlFor="acSimple">{{ $t('auth.user') }}</label>
                    </div>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon p-col-2">
                            <i class="pi pi-user"></i>
                        </span>
                        <InputText v-model="username" class="p-col-10" />
                    </div>

                    <div class="p-col-12">
                        <label htmlFor="acSimple">{{ $t('auth.password') }}</label>
                    </div>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon p-col-2">
                            <i class="pi pi-lock"></i>
                        </span>
                        <Password v-model="password" :feedback="false" class="p-col-10"/>
                    </div>

                    <div class="p-col-12">
                        <Button :label="$t('auth.login')" style="float: right;"/>
                    </div>

                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import AuthBusiness from "@/business/AuthBusiness";
    import ToastMessageBusiness from "@/business/ToastMessageBusiness";
    import ModalBusiness from "@/business/ModalBusiness";
    import EventBus from "@/commons/EventBus";
    import ConfigurationBusiness from "@/business/ConfigurationBusiness";
    import JWTBusiness from "@/business/JWTBusiness";
    import store from "@/store";

    export default {
        name: "Login",

        data() {
            return {
                username:undefined,
                password:undefined,
                pageConfiguration:{},
            }
        },

        beforeMount(){
            ModalBusiness.closeAllModals();
        },

        computed:{

            server(){
              return process.env.VUE_APP_SERVER;
            },

            backgroundImage(){
                return this.pageConfiguration.backgroundImage ? `url(${this.server + this.pageConfiguration.backgroundImage}` : 'url(assets/layout/images/default-allpaper.jpeg)';
            },

            logo(){
                return this.pageConfiguration.logo ? this.server + this.pageConfiguration.logo : 'assets/layout/images/logo-ancestryline-original-branco.jpeg';
            }

        },

        async mounted() {
            EventBus.loadingPage(true);
            this.pageConfiguration = await ConfigurationBusiness.getLoginPageConfiguration();
            EventBus.loadingPage(false);
        },

        methods: {
            async login(){

                let error = null;
                const token = await AuthBusiness.login(this.username, this.password).catch((e) => {
                    ToastMessageBusiness.showError('password.incorrect');
                    error = e;
                });

                if(!error){
                    JWTBusiness.setJwtToken(token);
                    const user = await AuthBusiness.getLoggedUser();
                    store.setLoggedUser(user);
                    await this.$router.push(this.$route.query && this.$route.query.redirect ? this.$route.query.redirect : {name : 'dashboard'});
                }

            },
        }
    }
</script>

<style scoped>
    body {
        margin: 0px;
    }
    .container {
        width: 100vw;
        height: 100vh;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .box {
        width: 300px;
        height: 450px;
        background-color: #1d1e23de;
        border-radius: 5px;
    }

    .dark .card {
        background: transparent;
    }

    .responsive {
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
    }

</style>
